import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { IconRedo } from '@components/icons/redo';
import { IconReward } from '@components/icons/reward';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { Tooltip } from '@components/tooltip';

import { Box } from 'components/Box';
import { useModal } from 'features/modals';
import { useStore } from 'models/Provider';

import { SharingEntry, RewardContainer } from './styles';

export const SharingJobList = observer(({ hasBanner, jobs }) => {
  const { t, lang } = useStore();
  const { showModal } = useModal();

  function shareModal(job) {
    showModal('SHARE_JOB_MODAL', {
      _container: {
        autoWidth: false,
        closeOnOverlayClickOrEsc: false,
      },
      job: job,
    });
  }
  return (
    <>
      {jobs.map((job) => (
        <SharingEntry key={job.id}>
          <Box w="100%">
            <Text font="bold16">{job.defaultLanguageData.title}</Text>
            <Text font="regular14" color="purple80">
              {job.locationDisplay(lang)} {job.workTypeDisplay(lang) && '• '}
              {job.workTypeDisplay(lang)}
            </Text>
          </Box>
          <Stack orientation="horizontal" space={2} justify="flex-end">
            {job.hasRewards && (
              <Box>
                <Tooltip content={t('sharejob.tips.reward')} placement="left">
                  <RewardContainer>
                    <IconReward />
                  </RewardContainer>
                </Tooltip>
              </Box>
            )}
            <Button
              tooltip={t('sharejob.tips.social')}
              icon={<IconRedo />}
              text={t('sharejob.button.submit')}
              onClick={() => shareModal(job)}
            />
          </Stack>
        </SharingEntry>
      ))}
    </>
  );
});
